import loadable from '@loadable/component';
import { LoadableFallback } from '../../../../../packages/LoadableHelpers';

export const AdvancedFiltersContentContainerLoadable = loadable(() => import('./AdvancedFiltersContentContainer'), {
  resolveComponent: ({ AdvancedFiltersContentContainer }) => AdvancedFiltersContentContainer,
  fallback: <LoadableFallback spinnerSize={42} />,
  ssr: false,
});
